import { FC, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import useI18n from "../../../../../hooks/useTranslations";
import { useRoofMaterialsApi } from "../../../../../http/patrol/useRoofMaterials";
import FlexContent from "../../../../ui/FlexContent";
import Header from "../../../../ui/Header";
import { PATROL } from "../../AdminSystemSettings";
import RoofMaterialDetails from "./RoofMaterialDetails";

const RoofMaterial: FC = () => {
  const i18n = useI18n();
  const { systemId } = useParams<{ systemId: string }>();
  const { roofMaterialId } = useParams<{ roofMaterialId: string }>();
  const roofMaterialsApi = useRoofMaterialsApi();

  const aborter = useRef(new AbortController());
  const { error, data, trigger } = roofMaterialsApi.getAdminRoofMaterial(aborter.current.signal);

  const path = [
    { url: `/admin/systems`, display: i18n.translation.systems.all },
    { url: `/admin/systems/${systemId}`, display: PATROL },
    {
      url: `/admin/systems/${systemId}/settings?tab=2&r_t=1`,
      display: `${i18n.translation.common.settings}: ${i18n.translation.roofMaterials.plural}`,
    },
    { display: data?.name ?? "" },
  ];

  useEffect(() => {
    roofMaterialId && trigger(roofMaterialId);
  }, [roofMaterialId]);

  return (
    <>
      <Header title={`${i18n.translation.roofMaterials.singular}: ${data?.name ?? ""}`} error={error} path={path} />
      <FlexContent padding direction="row">
        <RoofMaterialDetails roofMaterial={!error ? data : undefined} disabled={!!error || !data} />
      </FlexContent>
    </>
  );
};

export default RoofMaterial;
